<template>
    <div class="app-header-logo" role='none'>
        <div role='none' class="app-header-logo-img" v-html="require('!!raw-loader!@/assets/img/logo.svg').default"></div>
    </div>
</template>
<style lang="scss">
    .app-header-logo {
        width: 95%;
        max-width: 1300px;
        margin: 1em auto 0 auto;        
    }
.app-header-logo-img {
    aspect-ratio: 215/92;
}

.app-header-logo {
    height: 4em;
}

.app-header-logo-img {
    height: 100%;
}

.app-header-logo-img svg {
    width: 100%;
    height: 100%;
}

</style>
<script>
    export default{
        name: 'logo-com'
    }
</script>
